import styles from './index.module.less';
import MainInfo from './Main-Info';
import { capitalizeFirstLetter } from '@/lib/hooks/utils/utils';
import { useConfigProvider } from '@/context/ConfigProvider';

const Index = ({ platList1, platList2 }: { platList1: any; platList2: any }) => {
  const { isMobile } = useConfigProvider();
  return (
    <div className={styles.container}>
      <h2
        className={styles.title}
        id="Basic Information"
        style={{
          scrollMarginTop: isMobile ? '100px' : '200px',
          fontFamily: 'Inter-700',
        }}
      >
        {capitalizeFirstLetter(platList1.platform)} vs {capitalizeFirstLetter(platList2.platform)} :
      </h2>
      <ul className={styles.list}>
        <MainInfo platList={platList1} />
        <MainInfo platList={platList2} />
      </ul>
    </div>
  );
};

export default Index;
